import {apiCall} from "../utils/apiCall";
import {reposWebApi} from "./customerAPI";
import {refreshToken} from "./sessionAction";
import qs from "querystring";
import secureLocalStorage from "react-secure-storage";
import {GET_PAYMENT, PAY_LOADING} from "./orderActions";

export const PAYMENT_LOADING = 'LOADING';
export const GET_TRANSCATION_LIST = 'GET_TRANSCATION_LIST';
export const GET_TRANSCATION_LIST_FAIL = 'GET_TRANSCATION_LIST_FAIL';
export const GET_SELLERS_LIST = 'GET_SELLERS_LIST';
export const GET_SELLERS_LIST_FAIL = 'GET_SELLERS_LIST_FAIL';
export const GET_GRAPH_DETAILS = 'GET_GRAPH_DETAILS';
export const GET_GRAPH_DETAILS_FAIL = 'GET_GRAPH_DETAILS_FAIL';
export const GET_PAYMENT_BEHAVIOUR = 'GET_PAYMENT_BEHAVIOUR';
export const GET_PAYMENT_BEHAVIOUR_FAIL = 'GET_PAYMENT_BEHAVIOUR_FAIL';
export const GET_ORDER_REPORT = "GET_ORDER_REPORT";
export const GET_ORDER_REPORT_FAIL = "GET_ORDER_REPORT_FAIL";
export const GET_HDFC_URL_DATA = 'GET_HDFC_URL_DATA';
export const GET_HDFC_URL_FAIL = 'GET_HDFC_URL_FAIL';
export const PAYMENT_HDFC = 'PAYMENT_HDFC';
export const CLEAR_TRANSATIONS = 'CLEAR_TRANSATIONS';
export const CLOSE_HDFC_DIALOG = 'CLOSE_HDFC_DIALOG';
export const STORE_VAN_INVOICE = 'STORE_VAN_INVOICE';
export const GET_SUBSCRIPTION_LIST = 'GET_SUBSCRIPTION_LIST';
export const GET_SUBSCRIPTION_LIST_FAIL = 'GET_SUBSCRIPTION_LIST_FAIL';
export const GET_SUBSCRIPTION_BY_ID = 'GET_SUBSCRIPTION_BY_ID';
export const GET_SUBSCRIPTION_BY_ID_FAIL = 'GET_SUBSCRIPTION_BY_ID_FAIL';
export const GET_NON_AUTOPAY_SUBSCRIPTIONS = 'GET_NON_AUTOPAY_SUBSCRIPTIONS';
export const GET_NON_AUTOPAY_SUBSCRIPTIONS_FAIL = 'GET_NON_AUTOPAY_SUBSCRIPTIONS_FAIL';
export const GET_ASSETS_FOR_FILTER = "GET_ASSETS_FOR_FILTER";
export const GET_ASSETS_FOR_FILTER_FAIL = "GET_ASSETS_FOR_FILTER_FAIL";
export const ASSETS_LOADING = "ASSETS_LOADING";
export const CANCEL_AUTOPAY_SUCCESS = "CANCEL_AUTOPAY_SUCCESS";
export const CANCEL_AUTOPAY_FAIL = "CANCEL_AUTOPAY_FAIL";
export const CLEAR_NON_AUTOPAY_SUBSCRIPTIONS = "CLEAR_NON_AUTOPAY_SUBSCRIPTIONS";
export const CLEAR_SUBSCRIPTIONS = "CLEAR_SUBSCRIPTIONS";
export const SETUP_AUTOPAY_REQUEST = "SETUP_AUTOPAY_REQUEST";
export const SETUP_AUTOPAY_SUCCESS = "SETUP_AUTOPAY_SUCCESS";
export const SETUP_AUTOPAY_FAIL = "SETUP_AUTOPAY_FAIL";
export const GET_SUBSCRIPTION_DUE_LIST = 'GET_SUBSCRIPTION_DUE_LIST';
export const GET_SUBSCRIPTION_DUE_LIST_FAIL = 'GET_SUBSCRIPTION_DUE_LIST_FAIL';
export const GET_PARTNER_DUE_LIST = 'GET_PARTNER_DUE_LIST';
export const GET_PARTNER_DUE_LIST_FAIL = 'GET_PARTNER_DUE_LIST_FAIL';
export const PAYMENT_OVERVIEW_LOADING = 'PAYMENT_OVERVIEW_LOADING';
export const GET_PAYMENT_OVERVIEW = 'GET_PAYMENT_OVERVIEW';
export const GET_PAYMENT_OVERVIEW_FAIL = 'GET_PAYMENT_OVERVIEW_FAIL';
export const PARTNER_OVERVIEW_LOADING = 'PARTNER_OVERVIEW_LOADING';
export const GET_PARTNER_OVERVIEW = 'GET_PARTNER_OVERVIEW';
export const GET_PARTNER_OVERVIEW_FAIL = 'GET_PARTNER_OVERVIEW_FAIL';
export const PAYMENT_ACTIVITY_LOADING = 'PAYMENT_ACTIVITY_LOADING';
export const GET_PAYMENT_ACTIVITY = 'GET_PAYMENT_ACTIVITY';
export const GET_PAYMENT_ACTIVITY_FAIL = 'GET_PAYMENT_ACTIVITY_FAIL';
export const REVENUE_SUMMARY_LOADING = 'REVENUE_SUMMARY_LOADING';
export const GET_REVENUE_SUMMARY = 'GET_REVENUE_SUMMARY';
export const GET_REVENUE_SUMMARY_FAIL = 'GET_REVENUE_SUMMARY_FAIL';
export const TOTAL_FUEL_PURCHASE_LOADING = 'TOTAL_FUEL_PURCHASE_LOADING';
export const GET_TOTAL_FUEL_PURCHASE = 'GET_TOTAL_FUEL_PURCHASE';
export const GET_TOTAL_FUEL_PURCHASE_FAIL = 'GET_TOTAL_FUEL_PURCHASE_FAIL';
export const PARTNER_TOTAL_FUEL_PURCHASE_LOADING = 'PARTNER_TOTAL_FUEL_PURCHASE_LOADING';
export const GET_PARTNER_TOTAL_FUEL_PURCHASE = 'GET_PARTNER_TOTAL_FUEL_PURCHASE';
export const GET_PARTNER_TOTAL_FUEL_PURCHASE_FAIL = 'GET_PARTNER_TOTAL_FUEL_PURCHASE_FAIL';
export const PARTNER_CREDIT_UTILISATION_LOADING = 'PARTNER_CREDIT_UTILISATION_LOADING';
export const GET_PARTNER_CREDIT_UTILISATION = 'GET_PARTNER_CREDIT_UTILISATION';
export const GET_PARTNER_CREDIT_UTILISATION_FAIL = 'GET_PARTNER_CREDIT_UTILISATION_FAIL';
export const PARTNER_LIMIT_UPGRADE_LOADING = 'PARTNER_LIMIT_UPGRADE_LOADING';
export const GET_PARTNER_LIMIT_UPGRADE = 'GET_PARTNER_LIMIT_UPGRADE';
export const GET_PARTNER_LIMIT_UPGRADE_FAIL = 'GET_PARTNER_LIMIT_UPGRADE_FAIL';
export const SUBMIT_PARTNER_LIMIT_UPGRADE_LOADING = 'SUBMIT_PARTNER_LIMIT_UPGRADE_LOADING';
export const SUBMIT_PARTNER_LIMIT_UPGRADE = 'SUBMIT_PARTNER_LIMIT_UPGRADE';
export const SUBMIT_PARTNER_LIMIT_UPGRADE_FAIL = 'SUBMIT_PARTNER_LIMIT_UPGRADE_FAIL';
export const CREDIT_PARTNERS_LIST_LOADING = 'CREDIT_PARTNERS_LIST_LOADING';
export const GET_CREDIT_PARTNERS_LIST = 'GET_CREDIT_PARTNERS_LIST';
export const GET_CREDIT_PARTNERS_LIST_FAIL = 'GET_CREDIT_PARTNERS_LIST_FAIL';
export const INVOICE_AGEING_LOADING = 'INVOICE_AGEING_LOADING';
export const GET_INVOICE_AGEING = 'GET_INVOICE_AGEING';
export const GET_INVOICE_AGEING_FAIL = 'GET_INVOICE_AGEING_FAIL';
export const VERIFY_PAYMENT_AMOUNT = 'VERIFY_PAYMENT_AMOUNT';
export const VERIFY_PAYMENT_AMOUNT_FAIL = 'VERIFY_PAYMENT_AMOUNT_FAIL';
export const VERIFY_PAYMENT_AMOUNT_LOADING = 'VERIFY_PAYMENT_AMOUNT_LOADING';

//  **************** ALL Transcation API ************************

export const getAllPaymentTranscation = (formData, fetchMoreData) => {
    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: PAYMENT_LOADING,
            })
        }
        reposWebApi.get('/customer/get_customer_transactions', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params: formData
        })
            .then(response => {
                dispatch({
                    type: GET_TRANSCATION_LIST,
                    payload: response?.data?.data
                });
            })
            .catch(async error => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken())
                    dispatch(getAllPaymentTranscation(formData))
                } else dispatch({
                    type: GET_TRANSCATION_LIST_FAIL,
                    payload: error
                })
            });
    }
};

//  **************** ALL Partner List API ************************

export const getSellerList = (params, fetchMore = false) => {
    return (dispatch) => {
        if (!fetchMore) {
            dispatch({
                type: PAYMENT_LOADING,
            })
        }
        reposWebApi.get('/customer/get_credit_seller_list', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params
        })
            .then(response => {
                dispatch({
                    type: GET_SELLERS_LIST,
                    payload: response?.data?.data,
                    fetchMore,
                });
            })
            .catch(async error => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken())
                    dispatch(getSellerList(params, fetchMore))
                } else dispatch({
                    type: GET_SELLERS_LIST_FAIL,
                    payload: error
                })
            });
    }
};

//  **************** Graph List API ************************

export const getGraphDetails = (formData, loadChart) => {
    return async (dispatch) => {
        dispatch({
            type: PAYMENT_LOADING,
        })
        await reposWebApi.get('/customer/graph_credit_utilization', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params: formData
        }).then(response => {
            dispatch({
                type: GET_GRAPH_DETAILS,
                payload: response?.data?.data
            });
            loadChart(response?.data?.data);
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getGraphDetails(formData, loadChart))
            } else dispatch({
                type: GET_GRAPH_DETAILS_FAIL,
                payload: error
            })
        });
    }
};

//  **************** Payment Behaviour API ************************

export const getPaymentBehaviour = (formData) => {
    return async (dispatch) => {
        dispatch({
            type: PAYMENT_LOADING,
        })
        await reposWebApi.get('/customer/get_payment_behaviour', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params: formData
        }).then(response => {
            dispatch({
                type: GET_PAYMENT_BEHAVIOUR,
                payload: response?.data?.data
            });
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getPaymentBehaviour())
            } else dispatch({
                type: GET_PAYMENT_BEHAVIOUR_FAIL,
                payload: error
            })
        });
    }
};


//  **************** Sent all order report on mail API ************************

export const getSentReport = (enqueueSnackbar, setIsLoading) => {
    return async (dispatch) => {
        // dispatch({
        //     type: PAYMENT_LOADING,
        // })
        setIsLoading(true);
        await reposWebApi.get('/order/send_all_order_report', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
        }).then(response => {
            dispatch({
                type: GET_ORDER_REPORT,
                payload: response?.data?.data
            });
            setIsLoading(false);
            enqueueSnackbar("Report send successfully on your mail..!", {
                variant: 'success', anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getSentReport())
            } else dispatch({
                type: GET_ORDER_REPORT_FAIL,
                payload: error
            })
        });
    }
};

export const paymentViaHDFC = (enqueueSnackbar, value, RedirectPage, url, {json = false} = {}) => {
    return async (dispatch) => {
        dispatch({
            type: PAYMENT_HDFC,
        })
        const body = json ? value : qs.stringify(value);
        const headers = {
            Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token"),
            ...(json ? {'Content-Type': 'application/json'} : {}),
        };
        await reposWebApi.post(url ? url : '/payment/hdfc_initiate_payment', body, {
            headers,
        }).then(response => {
            dispatch({
                type: GET_HDFC_URL_DATA,
                payload: response?.data?.data
            });
            RedirectPage(response?.data?.data);
            enqueueSnackbar("hdfc payment get way is ready..!", {
                variant: 'success', anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(paymentViaHDFC(enqueueSnackbar, value, RedirectPage, url, {json}))
            } else dispatch({
                type: GET_HDFC_URL_FAIL,
                payload: error
            })
        });
    }
};

export const clearTranslation = () => {

    return async (dispatch) => {
        dispatch({
            type: CLEAR_TRANSATIONS,
        })
    }

}

export const closeHDFCDialog = () => ({
    type: "CLOSE_HDFC_DIALOG",
});

export const storeVanAndInvoice = (data) => ({
    type: 'STORE_VAN_INVOICE',
    payload: data
});

export const getAllSubscription = (param , fetchMoreData) => {
    return apiCall({
        url: '/rfd_subscription/list/subscription',
        params: param,
        method: 'get',  
        successType: GET_SUBSCRIPTION_LIST,
        failType: GET_SUBSCRIPTION_LIST_FAIL,
        fetchMoreData,
        loadingType: 'SUBSCRIPTION_LOADING',
    });
}

export const getSubscriptionById = (id) => {
    return apiCall({
        url: '/rfd_subscription/list/subscription',
        params: { id },
        method: 'get',
        successType: GET_SUBSCRIPTION_BY_ID,
        failType: GET_SUBSCRIPTION_BY_ID_FAIL,
        loadingType: 'SUBSCRIPTION_LOADING',
    });
}

export const getNonAutoPaySubscriptions = (params, fetchMoreData) => {
 return apiCall({
    url: '/rfd_subscription/list/subscription',
    params: { ...params, is_active: 0 }, // ensure is_active=0
    method: 'get',
    successType: GET_NON_AUTOPAY_SUBSCRIPTIONS,
    failType: GET_NON_AUTOPAY_SUBSCRIPTIONS_FAIL,
    fetchMoreData,
    loadingType: 'SUBSCRIPTION_LOADING',
  });
};

export const getAssetsForFilter = (params , fetchMoreData) => {
    return apiCall({
        url: "/rfd_subscription/list/assets",
        params: params,
        method: "get",
        successType: GET_ASSETS_FOR_FILTER,
        failType: GET_ASSETS_FOR_FILTER_FAIL,
        fetchMoreData,
        loadingType: ASSETS_LOADING,
    });
};

export const cancelAutoPay = (id, enqueueSnackbar) => {
  return async (dispatch) => {
    try {
      const response = await reposWebApi.post(
        "/rfd_subscription/cancel/auto_pay",
        { id },
        {
          headers: {
            Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
          },
        }
      );
      dispatch({
        type: CANCEL_AUTOPAY_SUCCESS,
        payload: response?.data?.data,
      });
      enqueueSnackbar("AutoPay Cancelled Successfully", {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return response?.data?.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        await dispatch(refreshToken());
        return await dispatch(cancelAutoPay(id, enqueueSnackbar));
      }
      dispatch({ type: CANCEL_AUTOPAY_FAIL, payload: error });
      enqueueSnackbar(
        error?.response?.data?.meta?.message ||
          "Failed to cancel AutoPay. Please try again.",
        {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        }
      );
      throw error;
    }
  };
};

export const clearNonAutoPaySubscriptions = () => ({
  type: CLEAR_NON_AUTOPAY_SUBSCRIPTIONS,
});

export const clearSubscriptions = () => ({
  type: CLEAR_SUBSCRIPTIONS,
});

export const getSubscriptionDueList = (params) => {
    return apiCall({
        url: '/payment/subscription_due_list',
        params,
        method: 'get',
        successType: GET_SUBSCRIPTION_DUE_LIST,
        failType: GET_SUBSCRIPTION_DUE_LIST_FAIL,
        loadingType: 'SUBSCRIPTION_DUE_LOADING',
    });
};

export const getPartnerDueList = (params) => {
    return apiCall({
        url: '/payment/partner_due_list',
        params,
        method: 'get',
        successType: GET_PARTNER_DUE_LIST,
        failType: GET_PARTNER_DUE_LIST_FAIL,
        loadingType: 'PARTNER_DUE_LOADING',
    });
};

// ponytail: drawer-only fetches — successType not in reducer, dashboard state untouched
export const getPartnerDueListDrawer = (params) =>
    apiCall({
        url: '/payment/partner_due_list',
        params,
        method: 'get',
        successType: 'DRAWER_PARTNER_DUE_LIST',
        failType: 'DRAWER_PARTNER_DUE_LIST_FAIL',
    });

export const getSubscriptionDueListDrawer = (params) =>
    apiCall({
        url: '/payment/subscription_due_list',
        params,
        method: 'get',
        successType: 'DRAWER_SUBSCRIPTION_DUE_LIST',
        failType: 'DRAWER_SUBSCRIPTION_DUE_LIST_FAIL',
    });

const getSetupAutopayErrorMessage = (error) => {
  return (
    error?.response?.data?.data?.error ||
    error?.response?.data?.meta?.message ||
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "Unable to setup AutoPay. Please try again."
  );
};

const getDefaultSuccessRedirectUrl = () => {
  if (typeof window !== "undefined" && window?.location?.origin) {
    return `${window.location.origin}/PaymentSuccess`;
  }
};

const getDefaultFailureRedirectUrl = () => {
  if (typeof window !== "undefined" && window?.location?.origin) {
    return `${window.location.origin}/PaymentFailed`;
  }
};

export const setupAutopay = (
  id,
  enqueueSnackbar,
  {
    redirect_url = getDefaultSuccessRedirectUrl(),
    cancel_url = getDefaultFailureRedirectUrl(),
  } = {}
) => {
  return async (dispatch) => {
    if (!id) {
      console.warn("setupAutopay called without id");
      return null;
    }

    dispatch({ type: SETUP_AUTOPAY_REQUEST });

    try {
      const formData = new FormData();
      formData.append("asset_id", id);
      formData.append("redirect_url", redirect_url);
      formData.append("cancel_url", cancel_url);

      const response = await reposWebApi.post(
        "/rfd_subscription/create_si",
        formData,
        {
          headers: {
            Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const payload = response?.data?.data;

      dispatch({
        type: SETUP_AUTOPAY_SUCCESS,
        payload,
      });

      if (enqueueSnackbar) {
        enqueueSnackbar("Redirecting to AutoPay setup...", {
          variant: "info",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }

      return payload;
    } catch (error) {
      if (error?.response?.status === 401) {
        await dispatch(refreshToken());
        return await dispatch(setupAutopay(id, enqueueSnackbar));
      }

      dispatch({
        type: SETUP_AUTOPAY_FAIL,
        payload: error,
      });

      if (enqueueSnackbar) {
        enqueueSnackbar(getSetupAutopayErrorMessage(error), {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }

      throw error;
    }
  };
};

// **************** Payment Overview API ************************

export const getPaymentOverview = ({customer_id}) => {
    return apiCall({
        url: '/payment/payment_overview',
        method: 'get',
        params: {customer_id},
        successType: GET_PAYMENT_OVERVIEW,
        failType: GET_PAYMENT_OVERVIEW_FAIL,
        loadingType: PAYMENT_OVERVIEW_LOADING,
    });
};

// **************** Revenue Summary (Fuel Purchase Analytics) API ************************

export const getRevenueSummary = ({customer_id, range_type, start_date, end_date }) => {
    return apiCall({
        url: '/payment/analytics/revenue_summary',
        method: 'get',
        params: {customer_id, range_type, start_date, end_date},
        successType: GET_REVENUE_SUMMARY,
        failType: GET_REVENUE_SUMMARY_FAIL,
        loadingType: REVENUE_SUMMARY_LOADING,
    });
};

// Fetch credit utilisation specific endpoint and store response in the same
// revenueSummary reducer slot so existing UI can continue using revenueSummary.
export const getCreditUtilisation = ({customer_id, limit = 10, offset = 0, range_type, start_date, end_date}) => {
    return apiCall({
        url: '/payment/analytics/credit_utilisation',
        method: 'get',
        params: { customer_id, limit, offset, range_type, start_date, end_date },
        successType: GET_REVENUE_SUMMARY,
        failType: GET_REVENUE_SUMMARY_FAIL,
        loadingType: REVENUE_SUMMARY_LOADING,
    });
};

// **************** Total Fuel Purchase API ************************

export const getTotalFuelPurchase = ({customer_id,
                                         range_type,
                                         comparison = true,
                                         start_date,
                                         end_date,
                                         comparison_start_date,
                                         comparison_end_date
                                     }) => {
    return apiCall({
        url: '/payment/analytics/total_fuel_purchase',
        method: 'get',
        params: { customer_id, range_type, comparison, start_date, end_date, comparison_start_date, comparison_end_date },
        successType: GET_TOTAL_FUEL_PURCHASE,
        failType: GET_TOTAL_FUEL_PURCHASE_FAIL,
        loadingType: TOTAL_FUEL_PURCHASE_LOADING,
    });
};

export const getPartnerTotalFuelPurchase = ({
    customer_id,
    partner_id,
    limit = 10,
    offset = 0,
    range_type,
    start_date,
    end_date,
    comparison_start_date,
    comparison_end_date,
}) => apiCall({
    url: '/payment/partner/total_fuel_purchase',
    method: 'get',
    params: {
        customer_id,
        partner_id,
        limit,
        offset,
        range_type,
        start_date,
        end_date,
        comparison_start_date,
        comparison_end_date,
    },
    successType: GET_PARTNER_TOTAL_FUEL_PURCHASE,
    failType: GET_PARTNER_TOTAL_FUEL_PURCHASE_FAIL,
    loadingType: PARTNER_TOTAL_FUEL_PURCHASE_LOADING,
});

export const getPartnerCreditUtilisation = ({
    customer_id,
    partner_id,
    limit = 10,
    offset = 0,
    range_type,
    start_date,
    end_date,
}) => apiCall({
    url: '/payment/partner/credit_utilisation',
    method: 'get',
    params: {customer_id, partner_id, limit, offset, range_type, start_date, end_date},
    successType: GET_PARTNER_CREDIT_UTILISATION,
    failType: GET_PARTNER_CREDIT_UTILISATION_FAIL,
    loadingType: PARTNER_CREDIT_UTILISATION_LOADING,
});

export const getPartnerLimitUpgradeRequest = ({customer_id, partner_id}) => apiCall({
    url: '/payment/partner/request_limit_upgrade',
    method: 'get',
    params: {customer_id, partner_id},
    successType: GET_PARTNER_LIMIT_UPGRADE,
    failType: GET_PARTNER_LIMIT_UPGRADE_FAIL,
    loadingType: PARTNER_LIMIT_UPGRADE_LOADING,
});

export const submitPartnerLimitUpgradeRequest = ({customer_id, partner_id}) => apiCall({
    url: '/payment/partner/request_limit_upgrade',
    method: 'post',
    data: {customer_id, partner_id},
    successType: SUBMIT_PARTNER_LIMIT_UPGRADE,
    failType: SUBMIT_PARTNER_LIMIT_UPGRADE_FAIL,
    loadingType: SUBMIT_PARTNER_LIMIT_UPGRADE_LOADING,
});

export const getCreditPartnersList = ({customer_id, limit = 50, offset = 0}) => apiCall({
    url: '/payment/list/credit_partners',
    method: 'get',
    params: {customer_id, limit, offset},
    successType: GET_CREDIT_PARTNERS_LIST,
    failType: GET_CREDIT_PARTNERS_LIST_FAIL,
    loadingType: CREDIT_PARTNERS_LIST_LOADING,
});

// **************** Invoice Ageing API ************************

export const getInvoiceAgeing = ({customer_id, limit = 5, offset = 0}) => {
    return apiCall({
        url: '/payment/analytics/invoice_ageing',
        method: 'get',
        params: { customer_id, limit, offset },
        successType: GET_INVOICE_AGEING,
        failType: GET_INVOICE_AGEING_FAIL,
        loadingType: INVOICE_AGEING_LOADING,
    });
};

export const getPaymentActivity = (params = {}, fetchMoreData = false) => {
    return apiCall({
        url: '/payment/activity',
        method: 'get',
        params,
        successType: GET_PAYMENT_ACTIVITY,
        failType: GET_PAYMENT_ACTIVITY_FAIL,
        loadingType: PAYMENT_ACTIVITY_LOADING,
        fetchMoreData,
    });
};

export const getPartnerOverview = ({partner_id, limit = 10, offset = 0}) => {
    return apiCall({
        url: '/payment/partner/overview',
        method: 'get',
        params: {partner_id, limit, offset},
        successType: GET_PARTNER_OVERVIEW,
        failType: GET_PARTNER_OVERVIEW_FAIL,
        loadingType: PARTNER_OVERVIEW_LOADING,
    });
};

const getDownloadFilename = (headers = {}, fallback = 'Payment_Receipt.pdf') => {
    const disposition = headers['content-disposition'] || headers['Content-Disposition'];
    const match = disposition?.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
    return match?.[1] ? decodeURIComponent(match[1]) : fallback;
};

const downloadBlobFile = (blobData, filename) => {
    const blob = new Blob([blobData], {type: 'application/pdf'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 100);
};

export const downloadActivityInvoice = (orderId, enqueueSnackbar) => {
    return async (dispatch) => {
        if (!orderId) {
            enqueueSnackbar?.('Order ID not found for this invoice.', {
                variant: 'error',
                anchorOrigin: {vertical: 'top', horizontal: 'right'},
            });
            return null;
        }

        try {
            const response = await reposWebApi.get('/order/mail_invoice/download', {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                },
                params: {order_id: orderId},
                responseType: 'blob',
            });

            downloadBlobFile(response.data, getDownloadFilename(response.headers, `Invoice_${orderId}.pdf`));
            enqueueSnackbar?.('Invoice downloaded successfully!', {
                variant: 'success',
                anchorOrigin: {vertical: 'top', horizontal: 'right'},
            });
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(downloadActivityInvoice(orderId, enqueueSnackbar));
            }
            const errMsg =
                error?.response?.data?.meta?.message ||
                error?.response?.data?.message ||
                'Unable to download invoice. Please try again.';
            enqueueSnackbar?.(errMsg, {
                variant: 'error',
                anchorOrigin: {vertical: 'top', horizontal: 'right'},
            });
            throw error;
        }
    };
};

export const downloadSubscriptionActivityInvoice = (id, enqueueSnackbar) => {
    return async (dispatch) => {
        if (!id) {
            enqueueSnackbar?.('Subscription invoice ID not found.', {
                variant: 'error',
                anchorOrigin: {vertical: 'top', horizontal: 'right'},
            });
            return null;
        }

        try {
            const response = await reposWebApi.post(
                '/rfd_subscription/v2/send_email_or_download',
                qs.stringify({is_mail: 0, id}),
                {
                    headers: {
                        Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    responseType: 'blob',
                }
            );

            downloadBlobFile(response.data, getDownloadFilename(response.headers, `Subscription_Invoice_${id}.pdf`));
            enqueueSnackbar?.('Subscription invoice downloaded successfully!', {
                variant: 'success',
                anchorOrigin: {vertical: 'top', horizontal: 'right'},
            });
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(downloadSubscriptionActivityInvoice(id, enqueueSnackbar));
            }
            const errMsg =
                error?.response?.data?.meta?.message ||
                error?.response?.data?.message ||
                'Unable to download subscription invoice. Please try again.';
            enqueueSnackbar?.(errMsg, {
                variant: 'error',
                anchorOrigin: {vertical: 'top', horizontal: 'right'},
            });
            throw error;
        }
    };
};

export const aiInsightFeedback = (payload, enqueueSnackbar) => {
    return async (dispatch) => {
        try {
            const formData = new FormData();
            formData.append('customer_id', payload.customer_id);
            formData.append('feedback_type', payload.feedback_type);
            if (Array.isArray(payload.feedback)) {
                payload.feedback.forEach((item) => formData.append('feedback', item));
            } else if (payload.feedback) {
                formData.append('feedback', payload.feedback);
            }
            if (payload.additional_comments) {
                formData.append('additional_comments', payload.additional_comments);
            }

            const response = await reposWebApi.post(
                '/payment/ai_insight_feedback',
                formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            return response?.data;
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(aiInsightFeedback(payload, enqueueSnackbar));
            }
            const errMsg =
                error?.response?.data?.meta?.message ||
                'Failed to submit feedback. Please try again.';
            if (enqueueSnackbar) {
                enqueueSnackbar(errMsg, {
                    variant: 'error',
                    anchorOrigin: {vertical: 'top', horizontal: 'right'},
                });
            }
            throw error;
        }
    };
};

/**
 * Dues-only initiate_payment. Sends invoice_list as a JSON array.
 * Does not change razorPayGateWay / payUGateWay (Place Order still uses qs + invoice_number).
 * Opens gateway the same way as existing flow via GET_PAYMENT + setIsPay (PaymentDialogs).
 */
export const buildDuesInitiatePayload = (verifyData = {}) => {
    const invoiceList = Array.isArray(verifyData.invoice_list) ? verifyData.invoice_list : [];
    const redirectInvoice = invoiceList[0] || '';

    return {
        invoice_list: invoiceList,
        redirect_invoice: redirectInvoice,
        redirect_url: `/PaymentSuccess?invoice_number=${redirectInvoice}`,
        cancel_url: `/PaymentFailed?invoice_number=${redirectInvoice}`,
        amount: Number(verifyData.total) || 0,
        selected_dues: Number(verifyData.selected_dues) || 0,
        available_balance:
            Number(verifyData.avialable_balance ?? verifyData.available_balance) || 0,
        card_type: verifyData.card_type,
        last_payment_method: verifyData.last_payment_method,
        is_amount_changed: Boolean(verifyData.is_amount_changed),
    };
};


export const initiateDuesPayment = (payload, enqueueSnackbar, setIsPay, {url} = {}) => {
    return async (dispatch) => {
        const invoiceList = Array.isArray(payload?.invoice_list) ? payload.invoice_list : [];
        if (!invoiceList.length) {
            enqueueSnackbar?.('No invoices found to pay.', {variant: 'error'});
            return null;
        }

        dispatch({type: PAY_LOADING});

        const body = {
            invoice_list: invoiceList,
            redirect_url: payload.redirect_url,
            cancel_url: payload.cancel_url,
        };

        try {
            const response = await reposWebApi.post(
                url || '/payment/initiate_payment',
                body,
                {
                    headers: {
                        Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                        'Content-Type': 'application/json',
                    },
                }
            );

            dispatch({
                type: GET_PAYMENT,
                payload: response?.data,
            });
            setIsPay && setIsPay(true);
            return response?.data;
        } catch (error) {
            setIsPay && setIsPay(false);
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(initiateDuesPayment(payload, enqueueSnackbar, setIsPay, {url}));
            }
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.meta?.message ||
                'Something went wrong!';
            enqueueSnackbar?.(errMsg, {
                variant: 'error',
                anchorOrigin: {vertical: 'bottom', horizontal: 'center'},
            });
            throw error;
        }
    };
};

const isValidVerifyAmountPayload = (payload = {}) => {
    const customerId = payload.customer_id;
    const amount = Number(payload.amount);
    const hasCustomer = customerId != null && customerId !== '';
    const hasAmount = Number.isFinite(amount) && amount > 0;
    const hasPartnerIds = payload.partner_ids != null && String(payload.partner_ids).length > 0;
    const hasAssetIds = payload.asset_ids != null && String(payload.asset_ids).length > 0;
    const hasPartnerId = payload.partner_id != null && String(payload.partner_id).length > 0;
    const hasAssetId = payload.asset_id != null && String(payload.asset_id).length > 0;
    const hasInvoiceNumber = payload.invoice_number != null && String(payload.invoice_number).trim().length > 0;
    return hasCustomer && (
        hasInvoiceNumber ||
        (hasAmount && hasPartnerIds && hasAssetIds) ||
        (hasAmount && hasPartnerId && hasAssetId)
    );
};

export const verifyPaymentAmount = (payload, enqueueSnackbar) => {
    return async (dispatch) => {
        if (!isValidVerifyAmountPayload(payload)) {
            const errMsg = 'Invalid payment verification payload.';
            if (enqueueSnackbar) {
                enqueueSnackbar(errMsg, {
                    variant: 'error',
                    anchorOrigin: {vertical: 'top', horizontal: 'right'},
                });
            }
            console.warn(errMsg, payload);
            return null;
        }

        dispatch({type: VERIFY_PAYMENT_AMOUNT_LOADING});

        try {
            const formData = new FormData();
            formData.append('customer_id', payload.customer_id);
            if (payload.partner_id != null) formData.append('partner_id', payload.partner_id);
            if (payload.partner_ids != null) formData.append('partner_ids', payload.partner_ids);
            if (payload.asset_id != null) formData.append('asset_id', payload.asset_id);
            if (payload.asset_ids != null) formData.append('asset_ids', payload.asset_ids);
            if (payload.invoice_number != null) formData.append('invoice_number', payload.invoice_number);
            formData.append('amount', payload.amount ?? 0);
            formData.append('balance', payload.balance ?? 0);

            const response = await reposWebApi.post(
                '/payment/verify_amount',
                formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            const data = response?.data?.data;
            dispatch({
                type: VERIFY_PAYMENT_AMOUNT,
                payload: data,
            });
            return response?.data;
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(verifyPaymentAmount(payload, enqueueSnackbar));
            }
            dispatch({
                type: VERIFY_PAYMENT_AMOUNT_FAIL,
                payload: error,
            });
            const errMsg =
                error?.response?.data?.meta?.message ||
                'Failed to verify payment amount. Please try again.';
            if (enqueueSnackbar) {
                enqueueSnackbar(errMsg, {
                    variant: 'error',
                    anchorOrigin: {vertical: 'top', horizontal: 'right'},
                });
            }
            throw error;
        }
    };
};

/**
 * GET /payment/summary — dues return flow.
 * Sends invoice_list as a comma-separated string (same invoices as verify_amount).
 */
export const getPaymentSummary = ({invoice_list} = {}) => {
    return async (dispatch) => {
        const params = {};
        const invoiceListParam =
            invoice_list == null ? '' : String(invoice_list).trim();
        if (invoiceListParam) {
            params.invoice_list = invoiceListParam;
        }

        try {
            const response = await reposWebApi.get('/payment/summary', {
                params,
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                },
            });
            return response?.data?.data;
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(getPaymentSummary({invoice_list}));
            }
            throw error;
        }
    };
};

/**
 * Client-side Razorpay verify for dues flow (handler mode).
 * Accepts 302 without following so the SPA can navigate with a real payment_id.
 */
export const verifyRazorpayPayment = ({
    order_id,
    razorpay_payment_id,
    razorpay_order_id,
    razorpay_signature,
}) => {
    return async (dispatch) => {
        const body = new URLSearchParams();
        body.append('order_id', order_id || razorpay_order_id || '');
        body.append('razorpay_payment_id', razorpay_payment_id || '');
        body.append('razorpay_order_id', razorpay_order_id || order_id || '');
        body.append('razorpay_signature', razorpay_signature || '');

        try {
            const response = await reposWebApi.post(
                '/payment/razerpay_verify_payment',
                body,
                {
                    headers: {
                        Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    maxRedirects: 0,
                    validateStatus: (status) =>
                        (status >= 200 && status < 300) || status === 302,
                }
            );
            return response;
        } catch (error) {
            // Axios may treat 302 as error depending on adapter; treat it as success.
            if (error?.response?.status === 302) {
                return error.response;
            }
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return await dispatch(
                    verifyRazorpayPayment({
                        order_id,
                        razorpay_payment_id,
                        razorpay_order_id,
                        razorpay_signature,
                    })
                );
            }
            throw error;
        }
    };
};
